import React, { useState } from 'react';

const InventoryContext = React.createContext(undefined);

const InventoryProvider = ({ children }) => {
    const lastQuery = 'search_inventory_last_query';
    const lastClicked = 'search_inventory_last_Clicked';

    const [query, setLastQuery] = useState(localStorage.getItem(lastQuery) ?
        JSON.parse(localStorage.getItem(lastQuery)) :
        {
            recherche: '',
            qte_imm_i: true,
            from: 1,
            to: 99999,
        });

    const [clicked, setLastClicked] = useState(localStorage.getItem(lastClicked) ?
        JSON.parse(localStorage.getItem(lastClicked)) : "");

    const setLastQueryJSON = (data) => {
        localStorage.setItem(lastQuery, JSON.stringify(data))
        setLastQuery(data)
    }

    const setLastClickedJSON = (data) => {
        localStorage.setItem(lastClicked, JSON.stringify(data))
        setLastClicked(data)
    }

    return (
        <InventoryContext.Provider value={{ query, setLastQueryJSON, clicked, setLastClickedJSON }}> {children} </InventoryContext.Provider>
    );
}

export { InventoryContext, InventoryProvider };

